import useJbEventFBPurchase from 'hooks/sendFBEventHooks/useJbEventFBPurchase';

const JbEventFBPurchaseProvider = ({
  customerId,
  orderId,
  cart,
  orderSummary,
  shipping,
}) => {
  useJbEventFBPurchase(customerId, orderId, cart, orderSummary, shipping);
  return null;
};

export default JbEventFBPurchaseProvider;
